import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import TextArea from '../../../../Atoms/TextArea';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import './styles.css';

export default function EditChallengeModal({ 
    show, 
    onHide, 
    challenge, 
    onConfirm 
}) {
    const [editedText, setEditedText] = useState('');

    useEffect(() => {
        if (challenge) {
            setEditedText(challenge.text || '');
        }
    }, [challenge]);

    const handleConfirm = () => {
        if (editedText.trim() && onConfirm) {
            onConfirm(editedText.trim());
            onHide();
        }
    };

    const handleCancel = () => {
        setEditedText(challenge?.text || '');
        onHide();
    };

    const isDisabled = !editedText.trim() || editedText.trim() === challenge?.text;

    return (
        <Modal 
            show={show} 
            onHide={handleCancel}
            centered
            backdrop="static"
            className="edit-challenge-modal"
        >
            <Modal.Header closeButton className="edit-challenge-modal-header">
                <Modal.Title>Editar Desafio</Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="edit-challenge-modal-body">
                <TextArea
                    placeholder="Descreva o desafio ou oportunidade..."
                    value={editedText}
                    onChange={(e) => setEditedText(e.target.value)}
                    maxLength={5000}
                    textAreaStyle={{ minHeight: '120px' }}
                    containerStyle={{ padding: '0px' }}
                />
                <div className="character-count">
                    {editedText.length}/5000 caracteres
                </div>
            </Modal.Body>
            
            <Modal.Footer className="edit-challenge-modal-footer">
                <ButtonSecondary onClick={handleCancel}>
                    Cancelar
                </ButtonSecondary>
                <ButtonMain 
                    onClick={handleConfirm}
                    disabled={isDisabled}
                >
                    Confirmar
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}
